export default __webpack_public_path__ + "static/media/mercado-pago.d81464a0.png";